class ScheduledBlock extends HTMLElement {
  constructor() {
    super();

    // Access the data-start-date attribute on the custom element itself
    const startDate = parseInt(this.dataset.startDate, 10);
    const endDate = parseInt(this.dataset.endDate, 10);
    const now = Math.floor(Date.now() / 1000);
    const { requestMode } = this.dataset;
    const { showSection } = this.dataset;

    // Ensure startDate and endDate are valid numbers
    if (Number.isNaN(startDate) || Number.isNaN(endDate)) {
      return;
    }

    // Guard clause for when the current time is outside the date range
    if (now <= startDate || now >= endDate) {
      return;
    }

    // Proceed if within the date range and requestMode is not present
    if (requestMode === 'false' && showSection === 'false') {
      this.fetchScheduledSection();
    }
  }

  async fetchScheduledSection() {
    const { sectionId } = this.dataset;
    if (!sectionId) {
      return;
    }

    const newUrl = `?section_id=${sectionId}&show_this_section`;

    try {
      const response = await fetch(newUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch section: ${response.statusText}`);
      }

      const data = await response.text();
      this.replaceSectionContent(data);
    } catch (error) {
      console.error(error);
    }
  }

  replaceSectionContent(htmlString) {
    // Parse the HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    // Find the new section in the fetched HTML
    const newSection = doc.querySelector('.js-scheduled-block');

    if (!newSection) {
      return;
    }

    // Replace the current element with the new section
    this.replaceWith(newSection);

    // add class to newSection
    newSection.classList.add('scheduled-switched');
  }
}

customElements.define('scheduled-block', ScheduledBlock);
